import { render, staticRenderFns } from "./PublishTypeDialog.vue?vue&type=template&id=0ff62379&scoped=true"
import script from "./PublishTypeDialog.vue?vue&type=script&lang=js"
export * from "./PublishTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./PublishTypeDialog.vue?vue&type=style&index=0&id=0ff62379&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff62379",
  null
  
)

export default component.exports